import {
	PREMIUM_BASE_PAINTS,
	TRANSPARENT_BASE_PAINTS,
} from 'shared/custom/constants/commonConstants';

export const processRowPaints = (
	rowPaintArray: string[],
	allPaintLines: string[],
	allLineColors: any[],
	manufacturer: string
) =>
	rowPaintArray
		.filter((paint) => paint !== '')
		.map((paint) => {
			const [quantity, code] = paint.split('|');
			let matchedColor = null;
			let matchedManufacturer = '';

			const lineIndex = allPaintLines.findIndex((line) =>
				manufacturer?.toUpperCase().includes(line.toUpperCase())
			);

			if (lineIndex !== -1) {
				const line = allPaintLines[lineIndex];
				const lineColors = allLineColors[lineIndex]?.colors || [];
				const foundColor = lineColors.find(
					(color: any) =>
						color.codigo === code ||
						(color?.valor === code && PREMIUM_BASE_PAINTS.includes(code)) ||
						(color?.valor === code && TRANSPARENT_BASE_PAINTS.includes(code))
				);

				if (foundColor) {
					matchedColor = foundColor;
					matchedManufacturer = line;
				}
			}

			return {
				paintColorName: matchedColor?.nombre || '',
				paintColor: {
					R: matchedColor?.R || 0,
					G: matchedColor?.G || 0,
					B: matchedColor?.B || 0,
				},
				paintCode: code,
				paintQuantity: quantity,
				paintManufacturer: matchedManufacturer,
				paintItemManufacturer: manufacturer,
				paintValue: matchedColor?.valor,
			};
		});
